import { router } from "@inertiajs/react";

export const handleSessionExpired = (error) => {
  if (error.response?.status === 419) {
    router.reload({ preserveScroll: true });
    return {
      shouldReject: true,
      rejection: {
        ok: false,
        problem: "SESSION_EXPIRED",
        originalError: error,
        data: {
          message: "Your session has expired. Please try again.",
          status: 419,
        },
      },
    };
  }
  return { shouldReject: false };
};

export const errorHandlers = [handleSessionExpired];
